import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 8652 15941"
    {...props}
  >
    <defs>
      <style>
        {".str2{stroke:#000;stroke-width:175.079}.fil0{fill:#1c1b17}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M673 4232h7301v-46c0-92-169-203-323-211H984c-15 1-37 4-59 9-134 33-252 128-252 202v46zm7468 166H506v-212c0-177 191-317 380-364 28-7 58-11 91-14h6679c231 13 485 178 485 378v212z"
        className="fill"
        style={{
          // stroke: "#000",
          strokeWidth: 459.525,
        }}
      />
      <path
        d="M6073 3850c58-289 115-578 173-867 16-79 32-157 47-236 1-3 1-5 2-8 125-625 250-1251 375-1876 27-134 37-297 84-428 10 5 24 11 41 17 79 28 192 18 296 9-152 759-303 1519-455 2278-17 81-33 162-49 244-58 289-116 578-173 867h226c58-289 115-578 173-867 16-82 33-163 49-244 158-789 316-1579 474-2369 14-69-31-140-107-140h-567c-46 0-98 34-108 81-162 810-324 1619-485 2428-16 81-33 162-49 244-58 289-116 578-173 867h226z"
        style={{
          fill: "#2b2a29",
          // stroke: "#2b2a29",
          strokeWidth: 459.525,
        }}
        className="fill"
      />
      <path
        d="m834 6561-16-163H613l16 163 257 2591h205zM7850 6398l-17 163-240 2425-17 166h206l16-166 241-2425 16-163h-8zM6839 15597H1829l-304-2067h-205l315 2258c5 37 48 66 101 66h5196c52 0 96-29 101-66l315-2258h-205l-304 2067zM1412 13326h5843l-5843-1z"
        className="fill stroke1"
        style={{
          strokeWidth: 175.079,
        }}
      />
      <path
        d="M8360 6145H292V4547h8068v1598zm103-1950H190c-57 0-102 78-102 176v1950c0 97 45 176 102 176h8273c56 0 102-79 102-176V4371c0-98-46-176-102-176zM7316 13076l-25 250H1376L983 9356h6702l-369 3720zm557-3891c-19-21-47-33-75-33H870c-29 0-56 12-76 33-19 22-29 50-26 79l414 4174c5 52 49 92 102 92h6100c52 0 96-40 102-92l36-362 377-3812c3-29-6-57-26-79z"
        className="fill stroke1"
        style={{
          strokeWidth: 175.079,
        }}
      />
    </g>
  </svg>
);
export default SvgComponent;
